import "./ListScrollViewport.scss";

/**
 * Dual-axis scroll container for Plan Manager list tables. Shows thin native
 * scrollbars when content overflows; props in, no local state.
 *
 * @param {object} props
 * @param {import('react').ReactNode} props.children
 * @param {(scrollElement: HTMLElement | null) => void} [props.onScroll]
 * @returns {import('react').JSX.Element}
 */
const ListScrollViewport = ({ children, onScroll }) => (
    <div
        className="table-wrapper plan-manager-list-scroll"
        onScroll={
            onScroll
                ? (event) => onScroll(event.currentTarget)
                : undefined
        }
    >
        {children}
    </div>
);

export default ListScrollViewport;
